document.addEventListener("DOMContentLoaded", function () {

  const inquireBtn = document.querySelector("#inquireButton");
  const popup = document.querySelector("#inquirePopup");
  const overlay = popup.querySelector(".inqury-modal__overlay");
  const form = document.querySelector("#inquireForm");
  const errorMessage = document.getElementById("inquireFormMessage");

  const LIST_ID = "YmNj7p";
  const COMPANY_ID = "KLrRKX";
  const API_URL = `https://a.klaviyo.com/client/subscriptions?company_id=${COMPANY_ID}`;

  /* -----------------------------
       OPEN MODAL
  -----------------------------*/
  function openModal() {
    popup.classList.remove("hidden");
    popup.setAttribute("aria-hidden", "false");
    overlay.classList.add("overlayActive");
    document.body.classList.add("no-scroll");
  }

  /* -----------------------------
       CLOSE MODAL (NO FLICKER)
  -----------------------------*/
  function closeModal() {
    popup.classList.add("hidden");
    popup.setAttribute("aria-hidden", "true");
    overlay.classList.remove("overlayActive");
    document.body.classList.remove("no-scroll");
  }

  // Cleanup after fade-out transition (prevents flicker)
  popup.addEventListener("transitionend", function () {
    if (!popup.classList.contains("hidden")) return;

    // Reset states only AFTER modal is fully hidden
    errorMessage.style.display = "none";
    form.classList.remove("hidden");
    document.getElementById("inquirySubtitle").classList.remove("hidden");
    document.getElementById("inquirySuccessScreen").classList.add("hidden");
    form.reset();
  });


  if (inquireBtn) {
    inquireBtn.addEventListener("click", function (e) {
      e.preventDefault();
      openModal();
    });
  }

  popup.querySelectorAll("[data-close-modal]").forEach(btn => {
    btn.addEventListener("click", closeModal);
  });

  overlay.addEventListener("click", closeModal);

  /* -----------------------------
       FORM SUBMISSION
  -----------------------------*/
  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    errorMessage.style.display = "none";

    const first_name = document.getElementById("inquire_first_name").value.trim();
    const last_name = document.getElementById("inquire_last_name").value.trim();
    const email = document.getElementById("inquire_email").value.trim();
    const phone = document.getElementById("inquire_phone").value.trim();

    if (!first_name || !last_name || !email || !phone) {
      errorMessage.textContent = "Please fill all fields.";
      errorMessage.style.display = "block";
      return;
    }

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Anniversary Edition Charm Popup",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
                first_name,
                last_name,
                properties: {
                  phone,
                  charm_inquiry: "Anniversary Edition Charm"
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: "list", id: LIST_ID } }
        }
      }
    };

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Accept": "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
          "Revision": "2024-10-15"
        },
        body: JSON.stringify(payload)
      });

      if (response.status === 202) {
        form.classList.add("hidden");
        document.getElementById("inquirySubtitle").classList.add("hidden");
        document.getElementById("inquirySuccessScreen").classList.remove("hidden");
        return;
      }

      if (response.status === 400) {
        const data = await response.json();
        errorMessage.textContent = data.errors[0].detail;
        errorMessage.style.display = "block";
        return;
      }

      errorMessage.textContent = "Error submitting form. Please try again.";
      errorMessage.style.display = "block";

    } catch (err) {
      errorMessage.textContent = "Error submitting form. Please try again.";
      errorMessage.style.display = "block";
    }
  });

});